function createEntry(en, es, value) {
  return {
    en,
    es,
    value,
  };
}

export const SourceOfFundsList = [
  createEntry('Savings', 'Ahorros', 'Savings'),
  createEntry('Scholarship', 'Beca', 'Scholarship'),
  createEntry('Social Security', 'Seguro Social', 'Social Security'),
  createEntry('Government Benefits', 'Beneficios del gobierno', 'Govt Benefits'),
  createEntry('Commissions', 'Comisiones', 'Commissions'),
  createEntry('Loan', 'Préstamo', 'Loan'),
  createEntry('Trust', 'Trust', 'Trust'),
  createEntry('Stock Sales', 'Venta de acciones', 'Stock Sales'),
  createEntry('Inheritance', 'Herencia', 'Inheritance'),
  createEntry('Legal Fees', 'Honorarios legales', 'Legal Fees'),
  createEntry('Dividends', 'Dividendos', 'Dividends'),
  createEntry('Business Income', 'Ingresos de negocio', 'Business Inc'),
  createEntry('Rental Income', 'Ingresos por alquiler', 'Rental Income'),
  createEntry('Interests', 'Intereses', 'Interests'),
  createEntry('Business Liquidation', 'Liquidación de negocios', 'Bus Liquidation'),
  createEntry('Lottery', 'Lotería', 'Lottery'),
  createEntry('Allowance', 'Allowance', 'Allowance'),
  createEntry('Insurance Policy', 'Póliza de seguro', 'Insurance Pol'),
  createEntry('Retirement Liquidation', 'Liquidación de jubilación ', 'Retirement Liq'),
  createEntry('Alimony', 'Pensión alimenticia', 'Alimony'),
  createEntry('Expense Reimburse', 'Reembolso de gastos', 'Exp Reimburse'),
  createEntry('Tax Reimburse', 'Reembolso de impuestos', 'Tax Reimburse'),
  createEntry('Salary', 'Sueldo', 'Salary'),
  createEntry('Business Sale', 'Venta de Negocio', 'Business Sale'),
  createEntry('Asset Sale', 'Venta de activos', 'Asset Sale'),
  createEntry('Property Sale', 'Venta de propiedades', 'Property Sale'),
];
